import { useFormContext } from "react-hook-form";
import { PersonFingerprintFormSchema } from "@core/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import "./form-person-fingerprint.scss";
import { useFormDropdownPersonContext } from "@domain/person/form-dropdown-person/form-dropdown-person.context";
import { useEffect } from "react";

type InputFormSchema = PersonFingerprintFormSchema;

export function FormPersonFingerprint() {
  const { control, setValue } = useFormContext<InputFormSchema>();
  const { selectedPersonData } = useFormDropdownPersonContext();
  const userCode = selectedPersonData?.code || "";
  useEffect(() => {
    setValue("userCode", userCode);
  }, [userCode]);

  return (
    <div id="FormPersonFingerprint" className="form-person-fingerprint">
      <InputDigitControl<InputFormSchema>
        control={control}
        name="fingerprintId"
        label="Fingerprint ID"
        className="w-full md:w-1/4"
        containerClassName="pb-2"
        placeholder="Enter fingerprint ID"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="deviceId"
        label="Device ID"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter device ID (optional)"
      />
    </div>
  );
}

export default FormPersonFingerprint;
